var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import useDesign from '../../../../../../../hooks/useDesign';
import { Truncate } from '../../../../../../atoms/Truncate/Truncate';
import { Label, TranslatedLabel, Wrapper } from './styles';
export var Spec = function (_a) {
    var design = _a.design, label = _a.label, value = _a.value, withBorder = _a.withBorder, withColumns = _a.withColumns;
    var _b = useDesign(design), schema = _b.schema, _c = _b.config, readMore = _c.readMore, readLess = _c.readLess;
    return (_jsxs(Wrapper, __assign({ className: "incentive__spec", "data-design": design, schema: schema, withBorder: withBorder, withColumns: withColumns }, { children: [typeof label === 'string' ? (_jsx(Label, __assign({ className: "incentive__spec__label" }, { children: label }))) : (_jsx(TranslatedLabel, { fontWeight: "600", i18n: label, className: "incentive__spec__label" })), _jsx(Truncate, __assign({ as: "span", className: "incentive__spec__value", readMore: readMore, readLess: readLess }, { children: value }))] })));
};
